<template>
  <div class="database-table a-card">
    <virtual-scroll-wrapper
      :headers="headers"
      :list="rows"
      emptyMessage="No Images Found"
      :count="count"
      :colspan="colspan"
      :loading="loading"
      :height="height"
      :selectOnly="selectOnly"
    >
      <template v-slot:default="{ item, colwidth }">
        <tr
          class="database-row color-alt canclick"
          :class="{ 'primary--text grey lighten-2': item.id === selected.id }"
          style="display: flex"
          @click="onclick(item)"
        >
          <div v-if="selectOnly" v-col-adjwidth="0" style="display: inline-flex; align-items: center">
            <input type="checkbox" :checked="item.id === selected.id" />
          </div>
          <td class="caption" v-col-adjwidth="'Name'" style="display: inline-flex; align-items: center">
            <a-truncate :text="item.name" />
          </td>
          <td class="caption" v-col-adjwidth="'Image'" style="display: inline-flex; align-items: center">
            <img :src="getPreview(item.name)" height="40px" alt="Preview" />
          </td>
        </tr>
      </template>
    </virtual-scroll-wrapper>
  </div>
</template>

<script>
export default {
  props: {
    query: Object,
    selectOnly: Boolean,
    height: String,
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Image", value: "name" },
      ],
      selected: {},
      rows: [],
      loading: true,
      page: 0,
      queryActive: false,
      count: 0,
    };
  },
  watch: {
    query(searchQuery) {
      this.launchQueryLoop(searchQuery);
    },
  },
  computed: {
    colspan() {
      return this.selectOnly ? 4 : 3;
    },
  },
  methods: {
    onclick(item) {
      if (this.selectOnly) {
        this.selected = item;
        this.$emit("select", this.selected);
        return;
      }
      this.goToPage(item);
    },
    goToPage(item) {
      this.$router.push({
        name: "image_info",
        params: { id: item.id },
      });
    },
    launchQueryLoop() {
      if (this.queryActive) return;

      this.queryActive = true;
      this.rows = [];
      this.page = 0;
      this.selected = {};
      this.loading = true;

      this.getDataCount(this.query);

      this._queryLoop(this.query)
        .then((data) => {
          this.queryActive = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$root.$error(err);
        });
    },
    _queryLoop(searchQuery) {
      return new Promise((resolve, reject) => {
        this._queryDatabase(this.query)
          .then((data) => {
            if (!data.rows.length) return resolve();
            this.rows.push(...data.rows);
            if (!data.continue) return resolve();
            this.page += 1;
            return this._queryLoop(this.query).then(resolve);
          })
          .catch((err) => reject(err));
      });
    },
    _queryDatabase(searchQuery) {
      return this.$store
        .dispatch("ImageStore/getImageList", {
          query: { ...searchQuery },
          page: this.page,
        })
        .then((rows) => {
          if (!rows || !rows.length) return { rows: [], continue: false };
          return { rows, continue: rows.length === 50 };
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
    getDataCount(searchQuery) {
      this.$store
        .dispatch("ImageStore/getImageCount", {
          query: searchQuery,
          page: this.page,
        })
        .then((count) => {
          this.count = count;
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
    getPreview(name) {
      return `${this.$store.getters["host"]}storage/images/` + name;
    },
  },
  mounted() {
    this.launchQueryLoop(this.query);
  },
};
</script>
